import React from 'react'
import { CrumbInfo } from './Breadcrumb'
import { useHistory } from 'react-router-dom'
import './BreadcrumbItem.css'

type Props = {
  item: CrumbInfo
}

function BreadcrumbItem(props: Props) {
  const { item } = props
  const history = useHistory()

  function onItemClick() {
    history.push(item.url)
  }

  if (item.enabled) {
    return (
      <span className="breadcrumb-item" onClick={onItemClick}>
        {item.text}
      </span>
    )
  } else {
    return (
      <span className="breadcrumb-item-disabled">
        {item.text}
      </span>
    )
  }  
}

export default BreadcrumbItem
